import { render, staticRenderFns } from "./ui-empty.vue?vue&type=template&id=225a4fa8&scoped=true"
import script from "./ui-empty.vue?vue&type=script&lang=js"
export * from "./ui-empty.vue?vue&type=script&lang=js"
import style0 from "./ui-empty.vue?vue&type=style&index=0&id=225a4fa8&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "225a4fa8",
  null
  
)

export default component.exports